import React from 'react'
import { toast } from 'react-toastify'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { LinearProgress } from '@mui/material'
import { groupApiSlice } from '../../../features/group/groupSlice'
import { teacherApiSlice } from '../../../features/teacher/teacherSlice'
import { H3 } from '../../../layouts/TextStyles'
import GroupsTable from './components/GroupsTable'
import AddGroupDialog from './components/AddGroupDialog'

const GroupListPage = () => {
    const { formatMessage } = useIntl()
    const { curators = [], isFetchingCurators } =
        teacherApiSlice.useFetchAllTeachersQuery(
            {
                query: `page=${0}&size=${10000}`,
                roles: ['CURATOR'],
            },
            {
                selectFromResult: ({ data, isFetching }) => ({
                    curators: data?.data,
                    isFetchingCurators: isFetching,
                }),
            },
        )
    const { data: groups = [], isFetching } =
        groupApiSlice.useFetchAllGroupsQuery(undefined, {
            refetchOnMountOrArgChange: true,
        })

    const [deleteGroup] = groupApiSlice.useDeleteGroupMutation()

    const handleDelete = async (id: number) => {
        await toast.promise(deleteGroup(id).unwrap(), {
            pending: formatMessage({ id: 'deleting' }),
            success: formatMessage({ id: 'deletedSuccess' }),
            error: formatMessage({ id: 'deleteFail' }),
        })
    }

    //  TODO: add loadings
    //  TODO2: add breadcrumbs

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'groups' })}</H3>
                    </Title>

                    <AddGroupDialog />
                </Header>

                {isFetching && <LinearProgress />}

                <GroupsTable
                    groups={groups}
                    curators={curators}
                    isFetchingCurators={isFetchingCurators}
                    onDelete={handleDelete}
                />
            </Content>
        </Wrapper>
    )
}

export default GroupListPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
